import { Show, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import theme from '../../style/theme';
import clsx from 'clsx';
import { StyledHeaderIcon } from '../header/header.style';

type UserControlsProps = {
    showLoginRegisterLabel?: boolean;
    usePadding?: boolean;
};

export const UserControls = (props: UserControlsProps) => {
    const {
        userState,
        localize,
        viewport,
        appStore,
        siteInfo,
    } = useContext(AppContext);
    const { openLoginMenu, close, openUserProfileMenu } = appStore;

    const isMobile = () => viewport.width <= theme.breakpoints.MOBILE;
    const isDesktop = () => !isMobile();
    const loggedIn = () => userState.user;
    const loggedOut = () => !loggedIn();

    const getInitials = () => {
        const user = userState.user;
        if (!user) return '';

        if (user.firstName && user.lastName) {
            return `${user.firstName[0]}${user.lastName[0]}`.toUpperCase();
        }

        if (user.firstName) {
            return user.firstName.substring(0, 2).toUpperCase();
        }

        if (user.email) {
            return user.email.substring(0, 2).toUpperCase();
        }

        return 'U';
    };

    const handleClickOpenLoginMenu = () => {
        close();

        if (userState.user) {
            openUserProfileMenu();
            return;
        }

        openLoginMenu();
    };

    const LoginButton = () => (
        <div class="flex justify-center items-center mx-xxs">
            <button
                class={clsx(
                    'flex items-center justify-center',
                    'pl-s',
                    'pr-s',
                    'pt-xxxs',
                    'pb-xxxs',
                    'rounded-large',
                    '!bg-grey-500',
                    'text-white',
                    'font-atos-bold',
                    'text-[1.1rem]',
                    'cursor-pointer',
                    'border-none',
                    'transition-colors duration-200',
                    'whitespace-nowrap',
                    'hover:!bg-grey-400'
                )}
                tabIndex={0}
                onClick={handleClickOpenLoginMenu}
                aria-label={localize('header_login_icon', 'Link to Login / Register')}
            >
                {localize('log-in', 'LOG IN')}
            </button>
        </div>
    );

    const UserAvatar = () => (
        <StyledHeaderIcon>
            <button
                class={clsx(
                    'flex items-center justify-center',
                    'w-[3.5rem] h-[3.5rem]',
                    'rounded-full',
                    '!bg-grey-500',
                    'text-white',
                    'font-atos-bold font-extrabold',
                    'text-[1.4rem]',
                    'cursor-pointer',
                    'border-none',
                    'transition-colors duration-200',
                    'hover:!bg-grey-400',
                    props.usePadding && 'mx-[1.43rem]'
                )}
                onClick={handleClickOpenLoginMenu}
                title={userState.user?.email}
                aria-label={userState.user
                    ? localize('open-user-profile-menu', 'Open user profile menu')
                    : localize('open-login-menu', 'Open login menu')
                }
            >
                {getInitials()}
            </button>
        </StyledHeaderIcon>
    );

    return (
        <>
            <Show when={siteInfo.siteType === 'default'}>
                <Show when={loggedIn()}>
                    <UserAvatar />
                </Show>

                <Show when={loggedOut()}>
                    <Show when={appStore.isHcp()}>
                        <LoginButton />
                    </Show>
                </Show>
            </Show>

            <Show when={siteInfo.siteType === 'atos-care'}>
                <Show when={loggedIn()}>
                    <UserAvatar />
                </Show>

                <Show when={loggedOut()}>
                    <LoginButton />
                </Show>
            </Show>
        </>
    );
};
